import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { SupportTicket } from "@shared/types/localTypes/supportTickets.ts";

export const useSupportTicketsStore = defineStore("supportTickets", () => {
  // State
  const _supportTickets = ref<SupportTicket[]>([]);
  const _isLoading = ref<boolean>(true);

  // Getters
  const supportTickets = computed(() => _supportTickets.value);
  const isLoading = computed(() => _isLoading.value);

  // Actions
  const setSupportTickets = (tickets: SupportTicket[]) => {
    _supportTickets.value = tickets;
  };

  const clearSupportTickets = () => {
    _supportTickets.value = [];
    _isLoading.value = true;
  };

  const setIsLoading = (loading: boolean) => {
    _isLoading.value = loading;
  };

  return {
    supportTickets,
    isLoading,
    setSupportTickets,
    clearSupportTickets,
    setIsLoading,
  };
});
